import { FETCH_LOCALLY } from '../../constants/actionTypes'

export default (fetchLocallyState = 0, action) => {
    switch (action.type) {
        case FETCH_LOCALLY:
            return fetchLocallyState + 1
        default:
            return fetchLocallyState;
    }
}